import {
  makeStyles,
  createStyles,
  createTheme,
  responsiveFontSizes,
  useTheme
} from '@material-ui/core/styles';

export const theme = responsiveFontSizes(
  createTheme({
    palette: {
      primary: {
        main: '#004F50'
      },
      secondary: {
        main: '#00BBBB'
      },
      error: {
        main: '#EF4C35'
      }
    },
    typography: {
      fontFamily: 'canada-type-gibson, sans-serif',
      fontSize: 16,
      subtitle2: {
        fontStyle: 'normal',
        fontWeight: 500,
        letterSpacing: '2px',
        textTransform: 'uppercase'
      }
    }
  })
);

export const useStyles = (componentStyles) => {
  const providedTheme = useTheme();
  return makeStyles(createStyles(componentStyles(providedTheme)))();
};
